import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoggerService {
  private logs: { [key: string]: any[] } = {};

  constructor() {
    this.logs["error"] = [];

    this.overrideConsole();
  }

  private overrideConsole() {
    const originalError = console.error;

    console.error = (...args: any[]) => {
      this.logs["error"].push(args);
      originalError.apply(console, args);
    };
  }

  getLogs(level: string | null = null) {
    if (level) {
      return this.logs[level];
    }
    return this.logs;
  }

  getErrorLogs() {
    return this.getLogs("error");
  }
}
